import React from 'react';
import { Text } from 'react-konva';
import {
  fontFamily,
  dualPedigreeMode,
  spanOutDualPedigreeProfilessBy,
  fontArray,
  fullNameFontStyle,
  fullNameLineHeight,
   } from '../../library/constants';
import {
  isMobilePhone,
  isMobileTablet,
  getWidthKonvaText,
  widenGreatGrandParentsForDualPedigree,
  shiftForUnionRoot,
  getPropFromObjInArray,
  buildNameLineArray,
} from '../../library/calc';

class DateAlive extends React.Component {

  hovering(hovering){
    this.props.callRefObj({key: `node_n-${this.props.n}`, method: 'callHover', param: hovering});
  }

  render() {

    let {
      n,
      isGGP,
      idp,
      isChildrenOfDualPedFocusUnion,
      dualPedigreeObj,
      side,
      nodeObj,
      left,
      top,
      origTop,
      onClickedNode,
      cursorBecomesMove,
      cursorBecomesPointer,
      userTouchedNode,
      dateAlive,
      stopStageClickPropagation,
      setNodeForFlipFocus,
      setShowMobileFlipCard,
      fullNameLineArr,
      isPedigree,
      pedigreeIsTall,
      storePrIdToLocationHistory,
      fullnameArrBasedOnFontSize,
      isSingleChildForDualPedigree,
      shouldHideChildrenForDualPedigree,
    } = this.props;

    if( dualPedigreeMode &&
      typeof(dualPedigreeObj.includeDate) !== 'undefined' &&
      !dualPedigreeObj.includeDate){
      return null;
    }

    const shiftDown = {
      1: 9,
      2: 15,
      3: 21,
      4: 27,
    }

    const pedigreeLeft = (pedigreeIsTall ? 21: 15);
    left += ( isPedigree ? pedigreeLeft: 30);

    if(!isPedigree){
      top += typeof(shiftDown[fullnameArrBasedOnFontSize.length]) !== 'undefined'  ? shiftDown[fullnameArrBasedOnFontSize.length]: 0;

      if( fullnameArrBasedOnFontSize.length > 3) return null;

    } else if(!dualPedigreeMode){

      top += typeof(shiftDown[fullNameLineArr.length]) !== 'undefined'  ? shiftDown[fullNameLineArr.length]: 0;

    } else if(dualPedigreeMode){

      const usesCustomName = typeof(nodeObj.dualPedigreeCustom) !== 'undefined' &&
      typeof(nodeObj.dualPedigreeCustom.profileName) !== 'undefined';

      let lengthOfCustomProfileName = undefined
      if(usesCustomName){

        const width = getPropFromObjInArray({arr: fontArray, searchkey: fontFamily, key: 'name', value: 'width'});
        const { fullNameLineArr } = buildNameLineArray({nm: nodeObj.dualPedigreeCustom.profileName, n, width});
        lengthOfCustomProfileName = fullNameLineArr.length;

      }

      top += ( usesCustomName ? shiftDown[lengthOfCustomProfileName]: shiftDown[fullNameLineArr.length]);

    }


    top -= 1 // make closer to name

    const width = (  !isPedigree ? 40: 48);

    const { dob_y, dod_y } = nodeObj;

    const hasBothDobAndDodYear = () => {
      return typeof(dob_y) !== 'undefined' && typeof(dod_y) !== 'undefined'
    }
    const fontSize = ( fullNameLineArr.length >=3 && hasBothDobAndDodYear() ? 4.0: 4.2);

    if( dualPedigreeMode ) top += 36;
    if( dualPedigreeMode && isGGP ) top -= 3;

    if ( dualPedigreeMode  && typeof(isChildrenOfDualPedFocusUnion) === 'undefined' ) {

      const fullNameTextWidth = getWidthKonvaText({
        str: dateAlive,
        fontSize,
        fontFamily,
        fontStyle: fullNameFontStyle,
        lineHeight: fullNameLineHeight
      })

      const midpointX = left + 8;

      left = midpointX - ( fullNameTextWidth / 2 );

      top = widenGreatGrandParentsForDualPedigree({top, idp});


      if( idp ===  1 ){ // Couple

        left = shiftForUnionRoot({side, left});


        if( side === 'left'){

          left += 4;

        }

        if( side === 'right'){

          left += 5;

        }


      } else {

        if( side === 'left'){

          left -= spanOutDualPedigreeProfilessBy - 4;

        }

        if( side === 'right'){

          left += spanOutDualPedigreeProfilessBy + 5;

        }

      }


    }

    if ( dualPedigreeMode  && typeof(isChildrenOfDualPedFocusUnion) !== 'undefined' ) {// bookmarkPleaseRemove DateAlive
      left += 50;
      top -= 21;
    }

    if ( dualPedigreeMode) {
      const shiftDown = 10;
      top += shiftDown;
    }


    if ( dualPedigreeMode && isGGP && side === 'right' ) left += 10
    if ( dualPedigreeMode && isGGP && side === 'left' ) left -= 10

    if(isSingleChildForDualPedigree({nodeObj: nodeObj})) {
      top = nodeObj.singleChildTop + 30;
    }

    if(dualPedigreeMode && shouldHideChildrenForDualPedigree({nodeObj: nodeObj})) return null;

    if(isSingleChildForDualPedigree({nodeObj: this.props.nodeObj}) &&  this.props.nodeObj.oneOfTooMany) {
      left += 20;
    }

    if( dualPedigreeMode && dualPedigreeObj.whichChildrenNode ===  -1 && typeof(origTop) !== 'undefined' ) top = origTop + 56  + shiftDown[fullNameLineArr.length];

    return <Text
      x={left}
      y={top}
      text={`${dateAlive}`}
      // text={`${dateAlive}-${n}`}
      // text={'(xxxx-xxxx)'}
      width={width}
      fontSize={fontSize}
      fontFamily={fontFamily}
      fill='#000000'

      onTouchStart={()=>{
        if(isMobileTablet() && dualPedigreeMode) return;
        stopStageClickPropagation({fromWhere: 'dateAliveComponent B'});

        userTouchedNode({
          node:n,
          callback: ()=>{
            if(isMobilePhone() ) {
              storePrIdToLocationHistory({userExitsFlipCard: false, prId: nodeObj.prId})
              setNodeForFlipFocus(n);
              setShowMobileFlipCard(n);
            }
            if(isMobileTablet() ) onClickedNode(n);
          },
          fromWhere: 'DateAlive'
        });
      }}

      onClick={()=>{
        if(isMobilePhone() || dualPedigreeMode) return;
        onClickedNode(n);
      }}

      onMouseenter={()=>{
        this.hovering(true);
        cursorBecomesPointer();
      }}

      onMouseleave={()=>{
        this.hovering(false);
        cursorBecomesMove();
      }}


    />;
  }
}

export default DateAlive;
